<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">{{ (isEdit ? 'Edit' : 'Add') + ' HTML Template' }}</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">

                    <div class="col-11 py-1 mx-auto">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> Form Name / Route </label>
                        <v-select
                            placeholder="Select Form Name / Route"
                            :options="formattedCustomizationManagerForms"
                            v-model="formData.form_name"
                            :reduce="name => name.id"
                            label="name"
                        />
                        <transition name="fade">
                          <span v-if="formError.form_name" class="invalid-feedback d-block qcont">{{ formError.form_name }}</span>
                        </transition>
                      </div>
                        <div class="mb-1">
                            <label class="form-label" for="fullName"> <span class="required">*</span> Template Name</label>
                          <v-select
                              placeholder="Select Template Name"
                              :options="formattedPatientCardTemplate"
                              v-model="formData.template_name"
                              :reduce="name => name.id"
                              label="name"
                          />
                            <transition name="fade">
                                <span v-if="formError.template_name" class="invalid-feedback d-block qcont">{{ formError.template_name }}</span>
                            </transition>
                        </div>

                      <div v-if="isEdit" class="mb-1">
                        <label class="form-label" for="fullName"> <span class="required">*</span>Status</label>
                        <v-select
                            placeholder="Select Status"
                            v-model="formData.status"
                            :options="status"
                            :reduce="name => name.value"
                            label="name"
                        />
                        <transition name="fade">
                          <span v-if="formError.status" class="invalid-feedback d-block qcont">{{ formError.status }}</span>
                        </transition>
                      </div>

                    </div>

                    <div class="col-12 text-center">
                        <button :disabled="loading" @click="submit" type="button" class="btn btn-primary me-1 waves-effect waves-float waves-light">
                            <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Submit
                        </button>
                        <button @click.prevent="onClickClose" class="btn btn-outline-secondary waves-effect">
                            Cancel
                        </button>
                    </div>
                    </div>
            </div>
        </div>
        <Loader v-if="loader"/>
    </div>
</template>

<script setup>
import handleChartAccount from '@/services/modules/chartAccount'
import Loader from "@/components/atom/LoaderComponent";
import handleRole from "@/services/modules/role";
import handleHospital from "@/services/modules/hospital";
import handleCompany from "@/services/modules/company";
import { computed, inject, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

const props = defineProps({
   isEdit:{
     type:Boolean,
     default:false
   },
    formData:{
      type:Object,
      default:{}
    }
});

const emit = defineEmits(['onCreateProfile', 'update:isEdit']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
const {fetchHome} = handleChartAccount()
const {fetchCompanyDefaultRoles} = handleRole();
const { storeCustomizationManager, updateCustomizationManager } = handleCompany();
const {dateOfBarthConvertToAge} = handleHospital()
const customizationManagerForms = ref({});
const patientCardTemplate = ref({});
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const status = ref([]);

const formattedCustomizationManagerForms = computed(() => {
    return Object.keys(customizationManagerForms.value).map(key => ({ id: key, name: customizationManagerForms.value[key] }));
})

const formattedPatientCardTemplate = computed(() => {
    return Object.keys(patientCardTemplate.value).map(key => ({ id: key, name: patientCardTemplate.value[key] }));
})

const formError = reactive({
  template_name: '',
  form_name: '',
  status: ''
})

//Functions and methods
const submit = async() => {
    if(checkValidation()) return;
    const query = getQuery();
    loading.value = true;

    if (!props.isEdit){
      await storeData(query)
      return
    }

    if (props.isEdit){
      await updateData(query)
    }
}

const storeData = async (query) => {
  await storeCustomizationManager(props.formData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    const resData = res.data;
    emit('onCreateCustomizationManager', resData);
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const updateData = async (query) => {
  await updateCustomizationManager(props.formData, props.formData.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    const resData = res.data;
    emit('onCreateCustomizationManager', resData);
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const checkValidation = () => {
    let flag = false;

    if(!props.formData.form_name){
        formError.form_name = 'Form Name/Route is required'
        flag = true;
    }

    if(!props.formData.template_name){
        formError.template_name = 'Template Name required'
        flag = true;
    }

    return flag;
}

const onClickClose = () => {
    props.isEdit = false
    $store.state.isModalOpenTwo = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

onMounted(() => {
  Promise.all([
    fetchHome().then(res => {
      if (!res.data) {
        return;
      }
      if (res.data.customization_manager_form) {
        customizationManagerForms.value = res.data.customization_manager_form
      }
      if (res.data.patient_card_template) {
         patientCardTemplate.value = res.data.patient_card_template
      }
      let statusType = res.data.status
      status.value = ["active", "inactive"].map(key => ({
        value:key,
        name: statusType[key],
      }));
    })
  ])
})
</script>
